import React from 'react'

function ServiceHeader() {
    return (
        <div className="z-10 w-full md:px-[120px] justify-end flex flex-row bg-[#E87D2C] border-b-4 border-[#1685CA]">
            <div className='p-[6px] text-sm leading-[23px] text-white flex flex-row gap-5 mobileHide'>
                <p>To Renew: <a href='tel:18001024465'>1800 102 4465</a></p>
                <p>For Service: <a href='tel:18001024462'>1800 102 4462</a></p>
                <p>To Buy: <a href='tel:18001024464'>1800 102 4464</a></p>
            </div>
            <button onClick={() => window.location.href = 'https://eservicing.manipalcigna.com/'} className='bg-[white] text-[#1685CA] font-bold text-sm ml-5 px-6 leading-7 hover:text-black py-1 rounded-tl-2xl rounded-tr-2xl'>
                Login
            </button>
        </div>
    )
}

export default ServiceHeader
